// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"qEGhdS","mainCell":"jfWTEM","sideCell":"XSqbd1","sticky":"VXuoHR","sideScrollWrapper":"a9xzuG"};